import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { SyncOptionsContactExport } from '../Enums/SyncOptionsContactExport.enum';

export class InputUserSyncOptionAddModifyRelation<
  T extends EMode = EMode.entity
> {
  /** Alias: id */
  id?: string;
  /** Alias: userCode */
  userCode?: any;
  /** Alias: contactsExportAllowed */
  contactsExportAllowed?: SyncOptionsContactExport;
  /** Alias: contactsExportMode */
  contactsExportMode?: SyncOptionsContactExport;
  /** Alias: contactsExportCustomer */
  contactsExportCustomer?: boolean;
  /** Alias: contactsExportSupplier */
  contactsExportSupplier?: boolean;
  /** Alias: contactsExportEmployees */
  contactsExportEmployees?: boolean;
  /** Alias: appointmentsSync */
  appointmentsSync?: boolean;
  /** Alias: appointmentsAllowPrivate */
  appointmentsAllowPrivate?: boolean;
  /** Alias: appointmentsSyncExternalAppointments */
  appointmentsSyncExternalAppointments?: boolean;
  /** Alias: mailboxId */
  mailboxId?: string;
  /** Alias: contactsIcludePrivateData */
  contactsIcludePrivateData?: boolean;
  /** Alias: appointmentsSyncPrivateItems */
  appointmentsSyncPrivateItems?: boolean;
  /** Alias: tenantCode */
  tenantCode?: number;
  /** Alias: contactsExportCustomerAllowed */
  contactsExportCustomerAllowed?: boolean;
  /** Alias: contactsExportSupplierAllowed */
  contactsExportSupplierAllowed?: boolean;
  /** Alias: contactsExportEmployeesAllowed */
  contactsExportEmployeesAllowed?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<InputUserSyncOptionAddModifyRelation> = {
  id: {
    alias: 'id',
  },
  userCode: {
    alias: 'userCode',
  },
  contactsExportAllowed: {
    alias: 'contactsExportAllowed',
  },
  contactsExportMode: {
    alias: 'contactsExportMode',
  },
  contactsExportCustomer: {
    alias: 'contactsExportCustomer',
  },
  contactsExportSupplier: {
    alias: 'contactsExportSupplier',
  },
  contactsExportEmployees: {
    alias: 'contactsExportEmployees',
  },
  appointmentsSync: {
    alias: 'appointmentsSync',
  },
  appointmentsAllowPrivate: {
    alias: 'appointmentsAllowPrivate',
  },
  appointmentsSyncExternalAppointments: {
    alias: 'appointmentsSyncExternalAppointments',
  },
  mailboxId: {
    alias: 'mailboxId',
  },
  contactsIcludePrivateData: {
    alias: 'contactsIcludePrivateData',
  },
  appointmentsSyncPrivateItems: {
    alias: 'appointmentsSyncPrivateItems',
  },
  tenantCode: {
    alias: 'tenantCode',
  },
  contactsExportCustomerAllowed: {
    alias: 'contactsExportCustomerAllowed',
  },
  contactsExportSupplierAllowed: {
    alias: 'contactsExportSupplierAllowed',
  },
  contactsExportEmployeesAllowed: {
    alias: 'contactsExportEmployeesAllowed',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputUserSyncOptionAddModifyRelationEntityDefinition: EntitiyDefinition<InputUserSyncOptionAddModifyRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputUserSyncOptionAddModifyRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
